import {Status as AutomationFileStatusGraphQL} from 'graphql-client/__generated/graphqlGlobalTypes';

import {AutomationOutputFileGraphQL} from '../../../graphql-fragments/lab-automation/__generated/AutomationOutputFileGraphQL';
import {ListAutomationOutputFiles_automationOutputFiles_AutomationOutputFileNode as ListAutomationOutputFile} from './__generated/ListAutomationOutputFiles';

type LiveAutomationOutputFile = ListAutomationOutputFile;

// Keep this logic in sync with the backend get_automation_output_file_effective_status in
// benchling/lab_automation/tools/automation_output_processing.py, which derives the same effective
// status (transform status overriding the output file status) for the assistant's tools.
export default function getStatusForOutputFileButton(
  automationOutputFile: AutomationOutputFileGraphQL | LiveAutomationOutputFile
): AutomationFileStatusGraphQL {
  if (automationOutputFile.status === AutomationFileStatusGraphQL.failed) {
    return automationOutputFile.status;
  }
  if (automationOutputFile.transforms) {
    for (const transform of automationOutputFile.transforms) {
      if (
        transform &&
        [AutomationFileStatusGraphQL.running, AutomationFileStatusGraphQL.failed].includes(transform.status)
      ) {
        return transform.status;
      }
    }
  }
  return automationOutputFile.status;
}
